module.exports = __webpack_public_path__ + "img/LPW_Shield.99fe46b1.png";